'use client';

import React__default, { useContext, useState, useEffect } from 'react';
import { DropdownContainerWrapper, EmptyFooter } from './DropdownContainer.css.js';
import { CascaderContext } from '../../context/reducer.js';
import { ACTIONS } from '../../context/actions.js';
import DropdownBody from '../DropdownBody/index.js';
import DropdownHeader from '../DropdownHeader/index.js';
import DropdownFooter from '../DropdownFooter/index.js';
import Popup from '../../../Popup/index.js';
import { ELanguage } from '../../../Utils/constants.js';

var DropdownContainer = function (params) {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, dispatch = _a.dispatch, t = _a.t;
    var isMobile = props.isMobile, floatingConfig = props.floatingConfig, selectOptions = props.selectOptions, onBlur = props.onBlur, lockTarget = props.lockTarget, scrollLockMode = props.scrollLockMode;
    var isShow = state.isShow;
    var _b = params.floatingState, refs = _b.refs, context = _b.context, FloatingPortal = _b.FloatingPortal;
    var _c = useState(false), isMounted = _c[0], setMounted = _c[1];
    var onAnimationEnd = function () {
        if (isShow) {
            return;
        }
        setMounted(false);
        dispatch({
            type: ACTIONS.HIDE
        });
    };
    useEffect(function () {
        if (!isShow) {
            return;
        }
        setMounted(true);
    }, [isShow]);
    var dropdownStyle = isMobile
        ? {}
        : {
            position: context.position,
            top: context.y,
            left: context.x,
            display: context.isReferenceHidden ? 'none' : 'block',
            zIndex: 1100
        };
    // console.log('casscader > lockTarget: ', lockTarget)
    return (React__default.createElement(React__default.Fragment, null, selectOptions.displayAsPopup && !isMobile ? (isMounted ? (React__default.createElement(Popup, { isShow: isShow, onClose: function () {
            dispatch({
                type: ACTIONS.HIDE
            });
            onBlur && onBlur();
        }, custom: {
            footer: null,
            lockTarget: lockTarget,
            scrollLockMode: scrollLockMode
        }, text: {
            header: t('Job Function')
        }, option: {
            isCloseOnClickBackdrop: true
        }, lang: ELanguage.EN },
        React__default.createElement(DropdownContainerWrapper, { isShow: isShow, isMobile: isMobile, "data-floating-placement": floatingConfig.placement, onAnimationEnd: onAnimationEnd, isSingleSelect: true },
            React__default.createElement(DropdownHeader, { isShowTitle: false }),
            React__default.createElement(DropdownBody, null),
            (selectOptions.isSingleSelect || selectOptions.hiddenFooter) && !isMobile ? (React__default.createElement(EmptyFooter, null)) : (React__default.createElement(DropdownFooter, null))))) : (React__default.createElement(React__default.Fragment, null))) : (React__default.createElement(FloatingPortal, { enable: floatingConfig.enablePortal }, isMounted ? (React__default.createElement("div", { ref: refs.setPopup, style: dropdownStyle },
        React__default.createElement(DropdownContainerWrapper, { isShow: isShow, isMobile: isMobile, "data-floating-placement": context.placement, onAnimationEnd: onAnimationEnd, isSingleSelect: false },
            React__default.createElement(DropdownHeader, { isShowTitle: true }),
            React__default.createElement(DropdownBody, null),
            (selectOptions.isSingleSelect || selectOptions.hiddenFooter) && !isMobile ? (React__default.createElement(EmptyFooter, null)) : (React__default.createElement(DropdownFooter, null))))) : (React__default.createElement(React__default.Fragment, null))))));
};

export { DropdownContainer as default };
//# sourceMappingURL=index.js.map
